import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";
// Boot Sentry before the first render so it captures mount-time errors.
// No-op when VITE_SENTRY_DSN_TMA is unset (see sentry-init.ts).
import { initSentry, reactErrorHandler, SentryErrorBoundary } from "./lib/sentry-init";

initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found. Check index.html has <div id='root'>");
}

// React 19 error hooks — route uncaught/caught/recoverable render errors to
// Sentry. No-op at runtime when Sentry has no DSN-configured client.
// Sentry's handler types errorInfo as React's `ErrorInfo` (componentStack:
// string | null); createRoot's options type it as { componentStack?: string }.
// The runtime shapes are identical — cast the handler to the option signature
// to satisfy exactOptionalPropertyTypes. One instance, reused for all three.
const handleReactError = reactErrorHandler() as unknown as (
  error: unknown,
  errorInfo: { componentStack?: string | undefined },
) => void;

createRoot(rootElement, {
  onUncaughtError: handleReactError,
  onCaughtError: handleReactError,
  onRecoverableError: handleReactError,
}).render(
  <StrictMode>
    <SentryErrorBoundary fallback={<p>Что-то пошло не так. Попробуйте перезапустить.</p>}>
      <App />
    </SentryErrorBoundary>
  </StrictMode>,
);
